const unprotectedPaths = ['/register', '/rsvp-error', '/error'];

export const isUnprotectedPath = (path) => unprotectedPaths.includes(path);
